export default {
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  SET_IS_EDIT: 'SET_IS_EDIT'
};



/** WEBPACK FOOTER **
 ** ./src/constants/modal.js
 **/